// src/components/FilterPopup.js
import React, { useState, useEffect } from "react";
import styles from "../styles/FilterPopup.module.css";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../context";
import { categoryData } from "./categoryData"; // or keep above this file

export default function FilterPopup({ onClose }) {
  const { filter, setFilter, setSelectedCategory, setSearchText } = useAppContext();
  const [localFilter, setLocalFilter] = useState(filter);
  const navigate = useNavigate();

  // Update local filter when context filter changes
  useEffect(() => {
    setLocalFilter(filter);
  }, [filter]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "mainCategory") {
      // Reset dependent fields when main category changes
      setLocalFilter({ mainCategory: value, subCategory: "", subSubCategory: "" });
    } else if (name === "subCategory") {
      // Reset sub-sub-category when sub changes
      setLocalFilter((prev) => ({ ...prev, subCategory: value, subSubCategory: "" }));
    } else {
      setLocalFilter((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleApply = () => {
    // Apply the filter
    setFilter(localFilter);
    
    // If mainCategory is selected in filter, also set it as selectedCategory
    if (localFilter.mainCategory) {
      setSelectedCategory(localFilter.mainCategory);
    }
    
    setSearchText("");
    navigate("/documents");
    onClose();
  };

  const handleReset = () => {
    const cleared = { mainCategory: "", subCategory: "", subSubCategory: "" };
    setLocalFilter(cleared);
    setFilter(cleared);
    setSelectedCategory(null);
    setSearchText("");
    onClose();
  };

  // Dropdown options
  const mainCategories = Object.keys(categoryData);
  const subCategories =
    localFilter.mainCategory && categoryData[localFilter.mainCategory]
      ? Object.keys(categoryData[localFilter.mainCategory])
      : [];
  const subSubCategories =
    localFilter.mainCategory &&
    localFilter.subCategory &&
    categoryData[localFilter.mainCategory][localFilter.subCategory]
      ? categoryData[localFilter.mainCategory][localFilter.subCategory]
      : [];

  return (
    <div className={styles.overlay}>
      <div className={styles.popup}>
        <h3 className={styles.title}>Filter Documents</h3>

        {/* Main Category */}
        <select
          className={styles.selectBox}
          name="mainCategory"
          value={localFilter.mainCategory}
          onChange={handleChange}
        >
          <option value="">Select Main Category</option>
          {mainCategories.map((cat) => (
            <option key={cat} value={cat}>
              {cat}
            </option>
          ))}
        </select>

        {/* Sub Category */}
        <select
          className={styles.selectBox}
          name="subCategory"
          value={localFilter.subCategory}
          onChange={handleChange}
          disabled={!subCategories.length}
        >
          <option value="">Select Sub Category</option>
          {subCategories.map((sub) => (
            <option key={sub} value={sub}>
              {sub}
            </option>
          ))}
        </select>

        {/* Sub-Sub Category */}
        <select
          className={styles.selectBox}
          name="subSubCategory"
          value={localFilter.subSubCategory}
          onChange={handleChange}
          disabled={!subSubCategories.length}
        >
          <option value="">Select Sub-Sub Category</option>
          {subSubCategories.map((subSub) => (
            <option key={subSub} value={subSub}>
              {subSub}
            </option>
          ))}
        </select>

        <div className={styles.buttonGroup}>
          <button className={styles.applyBtn} onClick={handleApply}>
            Apply
          </button>
          <button className={styles.resetBtn} onClick={handleReset}>
            Reset
          </button>
          <button className={styles.closeBtn} onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}